import { getApisRoot, getHeaders } from '../common';

const baseUrl = getApisRoot('wl-content-service', 'content');

export const getHome = async (hash: string, deliveryType?: string) => {
  const query = `${deliveryType ? '&deliveryType=' + deliveryType : ''}`;
  const response = await fetch(`${baseUrl}/v1/home/${hash}?${query}`, {
    headers: await getHeaders(),
    method: 'GET',
  });
  return await response.json();
};

export const getBarHome = async (barId: string) => {
  const response = await fetch(`${baseUrl}/v1/home/bar?storeId=${barId}`, {
    headers: await getHeaders(),
    method: 'GET',
  });
  return await response.json();
};

export const getLanding = async (slug: string) => {
  const response = await fetch(`${baseUrl}/v1/cms/landings/${slug}`, {
    headers: await getHeaders(),
    method: 'GET',
  });

  const data = await response.json();
  return { ok: response.ok, status: response.status, data };
};
